import { Fragment, useContext, useState } from 'react'
import { IconType } from 'react-icons';
import { Menu, Transition } from '@headlessui/react'
import { useNavigate } from 'react-router-dom';
import { StateContext } from '../../services/context';
import { classNames } from '../../utils/utils'
import { SubscriptionModal } from '../Modals/SubscriptionModal';
import { MenuHamburgerIcon, MenuClosedIcon, DocuIcon,EditorIcon, ProfileIcon, HelpIcon, ExitIcon, LockClosedIcon } from '../../utils/iconFactory';
import { UserPlanType } from '../../utils/utils';

export default function MenuDropDown() {
  const navigate = useNavigate();
  const { user } = useContext(StateContext);
  const [isOpenSubscription, setIsOpenSubscription] = useState(false)

  type MenuItemType = {
    label: string,
    description: string,
    icon: IconType,
    href: string
  }

  const menuItems: MenuItemType[] = [
    { label: 'Főoldal', description: "Válassz ki egy feladatot, amiben az AIDA segíteni tud neked", icon: DocuIcon, href: '/' },
    { label: 'Szerkesztő', description: "Szerkessz és hozz létre új tartalmakat az AIDA segítségével.", icon: EditorIcon, href: '/edit'},
    { label: 'Dokumentumok', description: "Itt találod a korábban elmentett dokumentumokat.", icon: DocuIcon, href: '/documents'},
    { label: 'Profil', description: "Itt találod a fiókod részleteit, beállításait.", icon: ProfileIcon, href: '/profile'},
    { label: 'Segítségközpont', description: "Ha elakadnál, vagy kérdésed lenne, akkor szívesen segítünk.", icon: HelpIcon, href: '/help'},
  ];

  const isMenuItemLocked = (userPlan: string, itemPlan: UserPlanType) => {
    if ((userPlan as UserPlanType) === "premium") {
      return false
    }
    if ((userPlan as UserPlanType) === itemPlan) {
      return false
    }
    return true
  }

  return (
    <>
      <SubscriptionModal isVisible={isOpenSubscription} onClose={() => setIsOpenSubscription(false)} />
      <Menu as="div" className="relative inline-block text-left">
        {({ open }) => (
          <>
            <Menu.Button className={classNames(
              open ? "bg-blue10 border-blue20" : "bg-blue10 border-blue0 hover:bg-blue10 hover:border-blue20",
                "inline-flex w-full items-center justify-center",
                "border rounded-[2.5rem] py-3 px-6",
                "text-style-body1 focus:outline-none")}
            >
              {
                open ? (
                  <MenuClosedIcon className="mr-3" aria-hidden="true" />
                ) : (
                  <MenuHamburgerIcon className="mr-3" aria-hidden="true"/>
                )
              }
              Menü
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items id='menu-panel' className={classNames("z-49 absolute right-0 px-7 py-3 mt-2 w-[26rem] origin-top-right",
                "divide-y divide-blue20 rounded-[1.563rem]",
                "bg-blue0 border border-blue20 menu-drop-shadow focus:outline-none")}
              >
              {menuItems.map((item, index) => (
                <Menu.Item key={index}>
                  {({ active }) => (
                    <button
                      className={classNames('group relative py-4 group flex w-full cursor-pointer')}
                      onClick={() => {(item.label === "Szerkesztő" && user.plan === "standard") ? setIsOpenSubscription(true) : navigate(item.href)}}
                    >
                      <div id='menu-item-wrapper' className='relative flex flex-col'>
                        {(item.label === "Szerkesztő" && user.plan === "standard") && 
                          <LockClosedIcon className="absolute top-0 right-0 h-6 w-6 text-gray40 fill-current group-hover:animate-wiggle" />
                        }
                        <div id='menu-item-header' className='flex flex-row gap-2'>
                          <item.icon id='menu-item-icon' 
                            className={classNames(
                              active ? 'text-primaryAction' : 'text-gray150',
                              'h-8 w-8 fill-current flex-no-shrink')} 
                            aria-hidden="true" />
                          <p id='menu-item-label' className={classNames(active ? 'text-primaryAction' : 'text-textMain','text-style-sub1')}>
                            {item.label}
                          </p>
                        </div>
                        <p id='menu-item-description' className='px-10 text-left text-textSecondary text-style-menu-description'>
                            {item.description}
                        </p>
                      </div>
                    </button>
                  )}
                </Menu.Item>
              ))}
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
    </>
  )
}